

import { Component, OnInit, ElementRef, Inject, AfterViewInit ,NgZone} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Router, ActivatedRoute, Params } from '@angular/router';
import swal from 'sweetalert2';
import { UserService } from '../../services/user.service';
import { PagoService } from '../../services/pago.service';
import { Pago } from '../../models/pago';
import { PaymentrequestComponent } from './paymetrequestmodal/paymentrequest.component';
import { Methods } from 'src/app/shared/methods';
import { Cell, DinamicData } from 'src/app/models/dinamic-data';
import { ConfigService } from '../../services/config.service';
import { MatSelectChange } from '@angular/material/select';
import { lastValueFrom } from 'rxjs';
import { ViewpaymentComponent } from './viewpayment/viewpayment.component';
import Swal from 'sweetalert2';
import { RejectpaymentComponent } from './rejectpayment/rejectpayment.component';
import { EditpaymentComponent } from './editpayment/editpayment.component';
import { GuiGuard } from "../../shared/guard/base-gui-guard";

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare const $: any;

@Component({
    selector: 'app-listpagos-cmp',
    templateUrl: 'listpagos.component.html',
    styleUrls: ['./listpagos.component.css'],
    providers: [UserService, PagoService,GuiGuard]
})

export class ListpagosComponent implements OnInit, AfterViewInit {
  private statusMap: Record<number, string> = {};
  public filtros = [
    null,
    {
      key: "id",
      title: "ID",
      value: "",
      type: "contains",
      key_type: "id_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
      ],
    },
    {
      key: "request_date",
      title: "Request Date",
      value: "",
      type: "equalto",
      key_type: "request_date_type",
      type_options: [
        { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
      ],
    },{
      key: "payment_type",
      title: "Payment Type",
      value: "",
      type: "contains",
      key_type: "payment_type_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },

      ],
    },
    {
      key: "vendor",
      title: "Vendor",
      value: "",
      type: "contains",
      key_type: "vendor_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },

      ],
    },
    {
      key: "rep",
      title: "Requested by",
      value: "",
      type: "contains",
      key_type: "rep_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
      ],
    },{
      key: "status",
      title: "Status",
      value: "",
      type: "contains",
      key_type: "status_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
      
      ],
    },
    {
      key: "amount",
      title: "Amount",
      value: "",
      type: "equalto",
      key_type: "amount_type",
      type_options: [
        { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
      ],
    },
    {
      key: "method",
      title: "Method",
      value: "",
      type: "contains",
      key_type: "method_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },

      ],
    },
    {
      key: "urgency",
      title: "Urgency",
      value: "",
      type: "contains",
      key_type: "urgency_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
      ],
    },
    {
      key: "due_date",
      title: "Due Date",
      value: "",
      type: "equalto",
      key_type: "due_date_type",
      type_options: [
        { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
      ],
    },
    
  ];
  public selectedStatuses: string[] = [];
  public previousStatuses: string[] = [];
  get selectedStatusesLabel(): string {
    return (this.selectedStatuses || []).join(', ');
  }
  public statuses
  public privilegio;
  public identity;
  public token;
  public loading = false;
  public mtds: Methods = new Methods();
  public options: Array<any> = [];
  public paginaActual = 1;
  public itemsPorPagina = "10";
  public totalItems = 0;
  public totalPaginas = 1;
  public config: Array<any> = [];
  public listpaymment: DinamicData = new DinamicData(
    ['check','ID', 'Request Date', 'Payment Type', 'Vendor', 'Requested by','Status','Amount','Method','Urgency','Due Date','Actions']
  )
  public bulk: string[] = [];

  constructor(  public guard: GuiGuard,
    private titleService: Title,
    public dialog: MatDialog,
    private _route: ActivatedRoute,
    private _router: Router,
    private _pagoService: PagoService,private _config: ConfigService,    private ngZone: NgZone,
    private _userService: UserService) {
      this.titleService.setTitle( 'Payments' );
      this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
      this.identity = this._userService.getIdentity();
      this.token = this._userService.getToken();  
  }

  ngAfterViewInit() {
   
  }

  NewPaymentRequest() {
    const dialogRef = this.dialog.open(PaymentrequestComponent, {
      width: '1600px',
      height: '900px',
      // puedes pasar datos al form así:
      // data: { /* cualquier cosa que necesites */ }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadDataAsync();
    });
  }

    ngOnInit() {       
      this.statuses = [
        { value: 'Pending Approval', label: 'Pending Approval' },
        { value: 'Rejected', label: 'Rejected' },
        { value: 'Paid', label: 'Paid' },
        { value: 'Approved', label: 'Approved' },
        { value: 'Partially Approved', label: 'Partially Approved' },
        { value: 'Draft', label: 'Draft' },
        { value: 'All', label: 'All' },
      ];
      this.selectedStatuses = this.statuses
      .filter(
        (status) => status.value !== 'Paid' &&status.value !== 'All'
      )
      .map((status) => status.value);
      this.previousStatuses = [...this.selectedStatuses];


      this._config.getConfig('paymentlist').subscribe(
        r => {
          if (r.data) {
            console.log("r.data.data => ", r.data.data);
            this.options = JSON.parse(r.data.data);
            this.itemsPorPagina = r.data.pageLimit;
  
          } else {
            this.options = this.mtds.colopt(
              this.listpaymment.headers, [true,false]
            );
          }
          this.getlist();
        }, error => {
          this.mtds.notifyError(error.statusText, error.status);
          this.loading = false;
        }
      );
    }

   getlist( e=null ){
    this.loading = true;
    let data={statusso: this.selectedStatuses,sort : [this.filterrigh] ,order:this.sortStates,}
    this._pagoService.getlistpayment(this.token,data,e !== null ? e.page : 1,
      e !== null ? e.perPage : 10,this.filtros)
    .subscribe((response: any) => {
      if (response.status === 'success') { 
        this.paginaActual = Number(response.page_actual);
        this.itemsPorPagina = String(response.items_per_page);
        this.totalItems = Number(response.total_items_count);
        this.totalPaginas = Number(response.total_pages);
        this.listpaymment.rows = [];

        for (let element of response.data) {
          
          const status = element.status;
          const colorClass = 
            status === 'Pending Approval'    ? 'pending'   :
            status === 'Rejected'            ? 'danger'    :
            status === 'Paid'                ? 'paid'      :
            status === 'Approved'            ? 'success'   :
            status === 'Partially Approved'  ? 'partially' :
            /* por defecto, Draft u otro */   'dark';
            this.statusMap[element.id] = element.status;
          let actionButtons = [];

          actionButtons.push({
            icon: 'remove_red_eye',
            action: 'Detail',
            color: 'info'
          });
          if (element.status !== 'Paid' && this.guard.permissions('edit-payment')) {
            actionButtons.push({
              icon: 'edit',
              action: 'Edit',
              color: 'primary',
              title: 'Edit Payment'
            });
          }
          console.log("element => ", element);
          switch (element.status) {
            case 'Pending Approval':
            case 'Partially Approved':
              if (this.guard.permissions('approve-reject')) {
              actionButtons.push(
                { icon: 'check', action: 'Approve', color: 'primary', title: 'Approve' },
                { icon: 'close', action: 'Reject',  color: 'warn',    title: 'Reject'  }
              );
              }
              break;
          
            case 'Approved':
              actionButtons.push(
                { icon: 'attach_money', action: 'Paid',   color: 'accent', title: 'Mark as Paid' }
              );
              if (this.guard.permissions('approve-reject')) {
                actionButtons.push(
                  { icon: 'close', action: 'Reject', color: 'warn', title: 'Reject' }
                );
              }
              break;
          
            case 'Rejected':
              /* if (this.guard.permissions('approve-reject')) { 
              actionButtons.push(
                { icon: 'check', action: 'Approve', color: 'primary', title: 'Approve' }
              );
               } */
              break;
          
            // case 'Paid': // nada más
          }
          if(this.guard.permissions('delete-payment')){    
            actionButtons.push({
              icon: 'delete',
              action: 'Delete',
              color: 'danger',
              title: 'Delete Payment'
            });
          }
          const selected_value = this.bulk.includes(element.id.toString());

          this.listpaymment.rows.push(
            [ 
              new Cell(element.id , {
                type: "checkbox",
                selected: selected_value
               
              }),
              new Cell(element.id ?? '', { td_style: 'width:60px; min-width:60px; max-width:70px; padding-left:2px; padding-right:2px;' }),
              new Cell(element.createdAt !== null ?
                this.mtds.getFecha(
                  new Date(
                    element.createdAt.length === 10 ? element.createdAt + ' 00:00:00' : element.createdAt
                  ), 'MM-dd-yyyy'
                ) : '',{ td_style: 'width:80px; min-width:80px; max-width:80px; padding-left:2px; padding-right:2px;' }), 
              new Cell(element.paymentType ?? ''), 
              new Cell(element.clientNames ? element.clientNames + " " : element.clientNamesConsigments + " " ),
              new Cell(element.createdBy ? element.createdBy.name[0] + element.createdBy.surname[0] : '',{ td_style: 'width:80px; min-width:80px; max-width:80px; padding-left:2px; padding-right:2px;' }),
              new Cell(status ?? '', {
                class: `fw-lighter ${colorClass}`,
                color: colorClass
              }),
              new Cell(element.requestedAmount ?? '',{ td_style: 'width:80px; min-width:80px; max-width:80px; padding-left:2px; padding-right:2px;' }),
              new Cell(this.formatMethodLabel(element.paymentMethodDetail?.method)),
              new Cell(this.addSpacesToLabel(element.paymentDueType) ?? ''),
              new Cell(element.paymentDueDate !== null ?
                this.mtds.getFecha(
                  new Date(
                    element.paymentDueDate.length === 10 ? element.paymentDueDate + ' 00:00:00' : element.paymentDueDate
                  ), 'MM-dd-yyyy'
                ) : '',{ td_style: 'width:80px; min-width:80px; max-width:80px; padding-left:2px; padding-right:2px;' }),             
              new Cell(actionButtons, {type: 'actions'})
            ]
          );
        }
        this.loading = false;
      }
    }, err => {
      console.error('Error cargando empresas', err);
      this.loading = false;
    });
  }
  onStatusChange(event: MatSelectChange): void {

    let newSelections = event.value as string[];
  

    if (!this.previousStatuses.includes('All') && newSelections.includes('All')) {
      newSelections = ['All'];
    }

    else if (this.previousStatuses.includes('All') && newSelections.length > 1) {
      newSelections = newSelections.filter(status => status !== 'All');
    }

    if (newSelections.length === 0) {
      newSelections = ['All'];
    }

    this.selectedStatuses = newSelections;
    this.previousStatuses = [...newSelections]; 

    console.log("Selected statuses:", this.selectedStatuses);
   /*  this.getlist(); */
    this.loadDataAsync();
  }

  
  private latestRequestId = 0;
  async loadDataAsync(params?: any): Promise<void> {
  
    this.latestRequestId++;
    const currentRequestId = this.latestRequestId;
    try {
      this.loading = true;
      let data={statusso: this.selectedStatuses,sort : [this.filterrigh] ,order:this.sortStates,}

 
      const response = await lastValueFrom(
        this._pagoService.getlistpayment(this.token,data,
          this.paginaActual,
          this.itemsPorPagina,
          this.filtros,
        )
      );
      if (currentRequestId !== this.latestRequestId) {
        console.log('Respuesta antigua ignorada');
        return;
      }
      this.listpaymment = this.transformResponseToDinamicData(response);
    } catch (error: any) {
      this.mtds.notifyError(error.statusText, error.status);
    } finally {
     
      if (currentRequestId === this.latestRequestId) {
        this.loading = false;
      }
    }
  }

  private transformResponseToDinamicData(response: any): DinamicData { 
    const headers = [...this.listpaymment.headers]; 
    let row =  [];
    let rows = [];
    this.paginaActual = Number(response.page_actual);
    this.itemsPorPagina = String(response.items_per_page);
    this.totalItems = Number(response.total_items_count);
    this.totalPaginas = Number(response.total_pages);
    this.listpaymment.rows = [];

    for (let element of response.data) {
      
      const status = element.status;
      const colorClass = 
        status === 'Pending Approval'    ? 'pending'   :
        status === 'Rejected'            ? 'danger'    :
        status === 'Paid'                ? 'paid'      :
        status === 'Approved'            ? 'success'   :
        status === 'Partially Approved'  ? 'partially' :
        /* por defecto, Draft u otro */   'dark';
        this.statusMap[element.id] = element.status;
      let actionButtons = [];

      actionButtons.push({
        icon: 'remove_red_eye',
        action: 'Detail',
        color: 'info'
      });
      if (element.status !== 'Paid' && this.guard.permissions('edit-payment')) {
        actionButtons.push({
          icon: 'edit',
          action: 'Edit',
          color: 'primary',
          title: 'Edit Payment'
        });
      }
       
      console.log("element => ", element);
      switch (element.status) {
        case 'Pending Approval':
        case 'Partially Approved':
          if (this.guard.permissions('approve-reject')) {
          actionButtons.push(
            { icon: 'check', action: 'Approve', color: 'primary', title: 'Approve' },
            { icon: 'close', action: 'Reject',  color: 'warn',    title: 'Reject'  }
          );
          }
          break;
      
        case 'Approved':
          actionButtons.push(
            { icon: 'attach_money', action: 'Paid',   color: 'accent', title: 'Mark as Paid' }
          );
          if (this.guard.permissions('approve-reject')) {
            actionButtons.push(
              { icon: 'close', action: 'Reject', color: 'warn', title: 'Reject' }
            );
          }
          break;
      
        case 'Rejected':
          /* if (this.guard.permissions('approve-reject')) { 
          actionButtons.push(
            { icon: 'check', action: 'Approve', color: 'primary', title: 'Approve' }
          );
           } */
          break;
      
        // case 'Paid': // nada más
      }
      if(this.guard.permissions('delete-payment')){    
      actionButtons.push({
        icon: 'delete',
        action: 'Delete',
        color: 'danger',
        title: 'Delete Payment'
      });
    }
      const selected_value = this.bulk.includes(element.id.toString());
         
          

            row = [
              new Cell(element.id , {
                type: "checkbox",
                selected: selected_value
               
              }),
              new Cell(element.id ?? '', { td_style: 'width:60px; min-width:60px; max-width:70px; padding-left:2px; padding-right:2px;' }),
              new Cell(element.createdAt !== null ?
                this.mtds.getFecha(
                  new Date(
                    element.createdAt.length === 10 ? element.createdAt + ' 00:00:00' : element.createdAt
                  ), 'MM-dd-yyyy'
                ) : '',{ td_style: 'width:80px; min-width:80px; max-width:80px; padding-left:2px; padding-right:2px;' }),  
              new Cell(element.paymentType ?? ''), 
              new Cell(element.clientNames ? element.clientNames + " " : element.clientNamesConsigments + " " ),
              new Cell(element.createdBy ? element.createdBy.name[0] + element.createdBy.surname[0] : '',{ td_style: 'width:80px; min-width:80px; max-width:80px; padding-left:2px; padding-right:2px;' }),
              new Cell(status ?? '', {
                class: `fw-lighter ${colorClass}`,
                color: colorClass
              }),
              new Cell(element.requestedAmount ?? '',{ td_style: 'width:80px; min-width:80px; max-width:80px; padding-left:2px; padding-right:2px;' }),
              new Cell( this.formatMethodLabel(element.paymentMethodDetail?.method)),
              new Cell(this.addSpacesToLabel(element.paymentDueType) ?? ''),
              new Cell(element.paymentDueDate !== null ?
                this.mtds.getFecha(
                  new Date(
                    element.paymentDueDate.length === 10 ? element.paymentDueDate + ' 00:00:00' : element.paymentDueDate
                  ), 'MM-dd-yyyy'
                ) : '',{ td_style: 'width:80px; min-width:80px; max-width:80px; padding-left:2px; padding-right:2px;' }),            
              new Cell(actionButtons, {type: 'actions'})
              ]
        rows.push(row);
    }
    return new DinamicData(headers, rows);
  }

  formatMethodLabel(method?: string): string {
    if (!method) return '';
   
    const special = [
      'ACH_DOMESTIC',
      'WT_DOMESTIC',
      'WT_INTERNATIONAL'
    ];
    
    if (special.includes(method)) {
   
      const [sigla, ...rest] = method.split('_');
      return sigla + ' ' + rest.map(w => w.charAt(0) + w.slice(1).toLowerCase()).join(' ');
    }
  
    return method
      .split('_')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(' ');
  }

  public sortStates = ""; 
  public filterrigh = "";
  handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if(columnKey === this.filterrigh ){
      if(this.sortStates === "DESC"){
        this.sortStates = "ASC"
      }else{
        this.sortStates = "DESC"
      }
    } else{
      this.sortStates = "ASC"
    }
    this.filterrigh = columnKey;
   
    this.getlist();
  }

  action(e) {
    console.log(e);

    switch (e.action) {
      case 'Detail':
      
        
      this.dialog.open(ViewpaymentComponent, {
        width: '80vw',
        height: '900px',
        data: { id: e.id },
        autoFocus: false             
      });
      this.dialog.afterAllClosed.subscribe(() => {
        this.loadDataAsync();
      });
 
        break;
        case 'Approve':
          this.confirmApprove(e.id);
          break;
    
        case 'Reject':
          this.confirmReject(e.id);
          break;
    
        case 'Paid':
            this.confirmPaid(e.id);
            break;
        case 'Edit':
          this.dialog.open(EditpaymentComponent, {
            width: '80vw',
            height: '900px',
            data: { id: e.id },
            autoFocus: false
          });
          this.dialog.afterAllClosed.subscribe(() => {
            this.loadDataAsync();
          });
      break;
        case 'Delete':
            this.confirmDelete(e.id);
            break;
          
      
      
        }
  }
  private changeStatus(opts: { action: string, id: number, note?: string }) {
    const { action, id, note } = opts;
    const current = (this.statusMap[id] || '').toLowerCase();
    let newStatus: string;
    let actionType: string;
  
    switch (action) {
      case 'Approve':
        actionType = 'APPROVED';
        if (current === 'pending approval') {
          newStatus = 'Partially Approved';
        } else if (current === 'partially approved') {
          newStatus = 'Approved';
        } else if (current === 'rejected') {
       
          newStatus = 'Pending Approval';
        } else {
          
          newStatus = 'Approved';
        }
        break;
  
      case 'Reject':
        actionType = 'REJECTED';
        newStatus   = 'Rejected';
        break;
  
      case 'Paid':
        actionType = 'PAID';
        newStatus   = 'Paid';
        break;
  
      default:
        return;
    }
  
    const payload: any = { id, status: newStatus, action: newStatus };
    if (note) payload.note = note;
  
    this._pagoService.changestatus(this.token, payload)
      .subscribe({
        next: () => {
          this.showToast('success', `Status changed to ${newStatus}`, 2000);
          this.loadDataAsync();
        },
        error: err => this.mtds.notifyError(err.statusText, err.status)
      });
  }
  
  
  private confirmReject(paymentId: number) {
    Swal.fire({
      title: 'Are you sure?',
      text:  'Do you really want to reject this payment?',
      icon:  'warning',
      showCancelButton: true,
      buttonsStyling: false,

      customClass:{
    confirmButton: 'gts-btn-primary',
    cancelButton: 'gts-btn-primary-outline',
            },
      confirmButtonColor: '#9c27b0',
      confirmButtonText: 'Yes, reject it',
      cancelButtonText: 'No, keep it'
    }).then(result => {
      if (result.isConfirmed) {
        this.openRejectDialog(paymentId);
      }
    });
  }
  private confirmApprove(paymentId: number) {
    Swal.fire({
      title: 'Are you sure?',
      text:  'Do you really want to approve this payment?',
      icon:  'question',
      showCancelButton: true,
      buttonsStyling: false,

      customClass:{
    confirmButton: 'gts-btn-primary',
    cancelButton: 'gts-btn-primary-outline',
            },
      confirmButtonColor: '#9c27b0',
      confirmButtonText: 'Yes, approve it',
      cancelButtonText: 'No'
    }).then(result => {
      if (result.isConfirmed) {
        
        this.changeStatus({ action: 'Approve', id: paymentId });
      }
    });
  }
  
  private confirmPaid(paymentId: number) {
    this.dialog.open(ViewpaymentComponent, {
      width: '80vw',
      height: '900px',
      data: { id: paymentId },
      autoFocus: false             
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.loadDataAsync();
    });
    /* Swal.fire({
      title: 'Mark as paid?',
      text:  'This will set the status to Paid.',
      icon:  'question',
      showCancelButton: true,
      buttonsStyling: false,

      customClass:{
    confirmButton: 'gts-btn-primary',
    cancelButton: 'gts-btn-primary-outline',
            },
      confirmButtonColor: '#9c27b0',
      confirmButtonText: 'Yes, mark paid',
      cancelButtonText: 'Cancel'
    }).then(result => {
      if (result.isConfirmed) {
        this.changeStatus({ action: 'Paid', id: paymentId });
      }
    }); */
  }
  private openRejectDialog(paymentId: number) {
    const dialogRef = this.dialog.open(RejectpaymentComponent, {
      width: '400px',
      data: { paymentId }
    });
  
    dialogRef.afterClosed().subscribe((note: string | undefined) => {
      if (typeof note === 'string' && note.trim().length > 0) {
        
        this.changeStatus({ action: 'Reject', id: paymentId, note });
      }
    });
  }
  
  
  showToast(type, title, timer) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    })
    Toast.fire({
      icon: type,
      title: title
    });
  }
  private confirmDelete(paymentId: number) {
    Swal.fire({
      title: 'Are you sure?',
      text:  'This will permanently delete the payment.',
      icon:  'warning',
      showCancelButton: true,
      buttonsStyling: false,

      customClass:{
    confirmButton: 'gts-btn-primary',
    cancelButton: 'gts-btn-primary-outline',
            },
      confirmButtonColor: '#9c27b0',
      confirmButtonText: 'Yes, delete it',
      cancelButtonText: 'Cancel'
    }).then(result => {
      if (result.isConfirmed) {
        this._pagoService.deletepayment(this.token, { id: paymentId })
          .subscribe({
            next: () => {
              Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: 'The payment has been deleted.',
                timer: 2000,
                showConfirmButton: false
              });
              this.loadDataAsync();  
            },
            error: err => this.mtds.notifyError(err.statusText, err.status)
          });
      }
    });
  }
  
  updateConfig(e) {
    this.options = e;
    console.log(this.options);
    this._config.setConfig('paymentlist', this.options).subscribe(
      r => {
        console.log(r);
      }
    );
  }
  addSpacesToLabel(str: string): string {
    
    if (!str) return '';
    return str.replace(/([a-z])([A-Z])/g, '$1 $2')
              .replace(/_/g, ' ') 
              .replace(/^./, (s) => s.toUpperCase());   
  }
}

